// PostHog project settings shared by the browser SDK (src/lib/analytics/client.ts),
// the same-origin ingestion proxy (src/services/analytics/proxy.ts) and
// server-side capture (src/services/analytics/server.ts).

// Public project token — it only allows sending events, so it is safe in the bundle.
export const POSTHOG_PROJECT_TOKEN = "phc_Ha2cIe7vGEgyn4fPA7B5g7n8DtAlVvcwF1SNvaO3drf";
export const POSTHOG_API_HOST = "https://us.i.posthog.com";
export const POSTHOG_ASSET_HOST = "https://us-assets.i.posthog.com";
export const POSTHOG_UI_HOST = "https://us.posthog.com";

// Browser traffic goes to this path on our own origin so ad blockers that
// block *.posthog.com don't drop it. Deliberately bland: blocklists match
// paths like /analytics, /tracking and /posthog.
export const POSTHOG_PROXY_PATH = "/relay-hh";

const PRODUCTION_HOSTS = new Set(["hearinghighlights.com", "www.hearinghighlights.com"]);

/**
 * Only production traffic is tracked. Preview deploys are production builds
 * too (and run the Playwright E2E suite), so gating on the build mode alone
 * would leak test signups into the PostHog project.
 */
export function isAnalyticsHost(hostname: string): boolean {
  return PRODUCTION_HOSTS.has(hostname);
}
